import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <a
      href={`#${comic.title}`}
      className="group relative block overflow-hidden rounded-xl bg-background-100"
      aria-label={`${comic.title} - ${comic.genre}漫画，共${comic.chapters}话`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} ${comic.genre}高清韩国漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        {comic.badge && (
          <span
            className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-0.5 text-xs font-bold text-white whitespace-nowrap ${
              comic.badge === "完结"
                ? "bg-secondary-500"
                : comic.badge === "爆款"
                  ? "bg-primary-500"
                  : "bg-accent-500"
            }`}
          >
            {comic.badge}
          </span>
        )}
        <span className="absolute right-2.5 top-2.5 inline-flex items-center gap-1 rounded-full bg-black/50 px-2 py-0.5 text-xs font-semibold text-white backdrop-blur">
          <i className="ri-star-fill text-secondary-400" aria-hidden="true" />
          {comic.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3">
          <h3 className="font-heading text-base leading-tight text-white">{comic.title}</h3>
          <p className="mt-0.5 text-xs text-white/80">{comic.author} · {comic.chapters}话{comic.status === "完结" ? " · 已完结" : " · 连载中"}</p>
        </div>
      </div>
      <div className="flex items-center justify-between px-3 py-2.5">
        <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-700">
          <i className={`ri-book-2-line text-primary-500`} aria-hidden="true" />
          {comic.status === "完结" ? "全一话可读" : "每日更新"}
        </span>
        <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-heart-3-fill text-primary-400" aria-hidden="true" />
          {(comic.likes / 1000).toFixed(1)}k
        </span>
      </div>
    </a>
  );
}